import { ScheduleSendMailEnum } from '@web-schedule/data';
import { getDateTimeByForm } from '@web-schedule/util';
import ics, { randomString } from '@web-common/components/util/ics';
import { apiHolder as api, apis } from 'api';
import { clazzMap, busyStatus, valiteMoment } from '@web-schedule/components/CreateBox/util';
import lOmit from 'lodash/omit';
import lCloneDeep from 'lodash/cloneDeep';
import { addEvent as calanderAddEvent } from '@web-schedule/service';
import { valitedMeetingError } from '@web-schedule/components/CreateBox/ScheduleForm';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { getIn18Text } from 'api';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const HtmlApi = api.api.requireLogicalApi(apis.htmlApi);
const formatCalDate = (param) => {
    const { y, m, d, hr, min, sec } = param;
    const val = `${y}/${m}/${d} ${hr}:${min}:${sec}`;
    return new Date(val).getTime();
};
const icsCreateUpload = async (uid, currentMail) => {
    var _a, _b, _c;
    const currentMailId = currentMail.cid;
    const conference = currentMail.conference;
    const summary = (_a = currentMail === null || currentMail === void 0 ? void 0 : currentMail.entry) === null || _a === void 0 ? void 0 : _a.title;
    const { location, enmuRecurrenceRule, moments: { startDate, startTime, endDate, endTime }, time: { allDay }, } = conference;
    const locationRes = location || getIn18Text('DEDIANDAIDING');
    const start = getDateTimeByForm(startDate, startTime, !!allDay);
    const end = getDateTimeByForm(allDay ? endDate.clone().add(1, 'days') : endDate, endTime, !!allDay);
    const icsFile = ics({
        start: formatCalDate(start),
        end: formatCalDate(end),
        receiver: currentMail.receiver,
        rruleVal: enmuRecurrenceRule,
        organizer: (_c = (_b = currentMail === null || currentMail === void 0 ? void 0 : currentMail.sender) === null || _b === void 0 ? void 0 : _b.contact) === null || _c === void 0 ? void 0 : _c.contact,
        location: locationRes,
        uid,
        summary,
    });
    const accounts = await accountApi.getMainAndSubAccounts();
    const mainAccount = accounts[0].mainAccount;
    const flag = {};
    const senderEmail = (currentMail === null || currentMail === void 0 ? void 0 : currentMail.initSenderStr) || '';
    if (mainAccount !== senderEmail) {
        flag._account = senderEmail;
    }
    await mailApi.doUploadAttachment({
        cid: currentMailId,
        attach: icsFile,
        uploader: {},
        flag,
        _account: flag._account,
    });
};
const uploadIcsFromServer = async (currentMail, icsText) => {
    const currentMailId = currentMail.cid;
    const accounts = await accountApi.getMainAndSubAccounts();
    const mainAccount = accounts[0].mainAccount;
    const flag = {};
    const senderEmail = (currentMail === null || currentMail === void 0 ? void 0 : currentMail.initSenderStr) || '';
    if (mainAccount !== senderEmail) {
        flag._account = senderEmail;
    }
    const icsFile = new File([icsText], 'calendar.ics');
    await mailApi.doUploadAttachment({
        cid: currentMailId,
        attach: icsFile,
        uploader: {},
        flag,
        _account: flag._account,
    });
};
const validataCalendar = (currentMail) => {
    const { conference } = currentMail;
    const { moments } = conference || {};
    return moments && valiteMoment(moments, getIn18Text('HUIYIJIESHUSHI'));
};
const calendarSubmit = async (params) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const { currentMail, setVisibleConf, isSendCurrentMail } = params;
    const { entry } = currentMail;
    const valid = validataCalendar(currentMail);
    if (!valid) {
        return true;
    }
    const conference = lOmit(lCloneDeep(currentMail.conference), 'meetingTipType');
    if ((_a = currentMail.conference) === null || _a === void 0 ? void 0 : _a.meetingTipType) {
        conference.meetingOrderParam = undefined;
        conference.location = '';
    }
    const condition = new Map();
    condition.set('senderMail', ScheduleSendMailEnum.NOT_SEND);
    condition.set('autoPrev', false);
    const required = ((_c = (_b = currentMail === null || currentMail === void 0 ? void 0 : currentMail.receiver) === null || _b === void 0 ? void 0 : _b.filter(i => i.mailMemberType === 'to')) === null || _c === void 0 ? void 0 : _c.map(i => { var _a, _b; return (_b = (_a = i === null || i === void 0 ? void 0 : i.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.accountName; })) || [];
    const optional = ((_e = (_d = currentMail === null || currentMail === void 0 ? void 0 : currentMail.receiver) === null || _d === void 0 ? void 0 : _d.filter(i => i.mailMemberType === 'cc')) === null || _e === void 0 ? void 0 : _e.map(i => { var _a, _b; return (_b = (_a = i === null || i === void 0 ? void 0 : i.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.accountName; })) || [];
    const descMax = 30000;
    let description = '';
    const attachments = (entry === null || entry === void 0 ? void 0 : entry.attachment) || [];
    const mailContent = ((_f = entry === null || entry === void 0 ? void 0 : entry.content) === null || _f === void 0 ? void 0 : _f.content) || '';
    if (attachments.length) {
        description += `<span style="color: #747a8c">${getIn18Text('YOUJIANFUJ')}：(${getIn18Text('QINGZAIYOUJZCK')})</span>\n`;
        attachments.forEach((item, index) => {
            const curAtt = ` ${index + 1}) ${(item === null || item === void 0 ? void 0 : item.fileName) || ''}`;
            description += curAtt;
        });
    }
    if (mailContent) {
        if (attachments.length) {
            description += `\n`;
        }
        description += `<span style="color: #747a8c">${getIn18Text('YOUJIANZHENGWEN')}：</span>`;
        const htmlObj = HtmlApi.parseHtml(mailContent);
        (_g = htmlObj.querySelector('.mail-signature')) === null || _g === void 0 ? void 0 : _g.remove();
        (_h = htmlObj.querySelector('.mail-signature-ent')) === null || _h === void 0 ? void 0 : _h.remove();
        const imgs = htmlObj.getElementsByTagName('img');
        Array.from(imgs).forEach(element => element.remove());
        const htmlText = ((_j = htmlObj === null || htmlObj === void 0 ? void 0 : htmlObj.body) === null || _j === void 0 ? void 0 : _j.innerHTML) || '';
        if (description.length + htmlText.length >= descMax) {
            const text = ((_k = htmlObj === null || htmlObj === void 0 ? void 0 : htmlObj.body) === null || _k === void 0 ? void 0 : _k.innerText) || '';
            description += `${text}`;
            description = description.substring(0, descMax - 3) + '...';
        }
        else {
            description += htmlText;
        }
    }
    const value = Object.assign(Object.assign({}, conference), { enmuReminders: [conference === null || conference === void 0 ? void 0 : conference.enmuReminders], reminders: [conference === null || conference === void 0 ? void 0 : conference.reminders], summary: (_l = currentMail === null || currentMail === void 0 ? void 0 : currentMail.entry) === null || _l === void 0 ? void 0 : _l.title, transp: busyStatus[0].value, clazz: clazzMap[0].value, description,
        required,
        optional });
    const uid = randomString();
    const cal = await calanderAddEvent(Object.assign(Object.assign({}, value), { uid, senderMail: condition.get('senderMail'), includeIcs: 1 }), condition);
    const code = Number((_m = cal.data) === null || _m === void 0 ? void 0 : _m.code);
    if (code !== 200) {
        if (!isSendCurrentMail) {
            SiriusMessage.error({
                content: ((_o = cal.data) === null || _o === void 0 ? void 0 : _o.err_msg) || getIn18Text('RICHENGBAOCUNSHI'),
            });
            return true;
        }
        if (!valitedMeetingError(code, () => {
            setVisibleConf(true);
        })) {
            SiriusMessage.error({
                content: ((_p = cal.data) === null || _p === void 0 ? void 0 : _p.err_msg) || getIn18Text('RICHENGBAOCUNSHI'),
            });
        }
        return true;
    }
    else {
        if ((_r = (_q = cal.data) === null || _q === void 0 ? void 0 : _q.data) === null || _r === void 0 ? void 0 : _r.icsText) {
            await uploadIcsFromServer(currentMail, (_t = (_s = cal.data) === null || _s === void 0 ? void 0 : _s.data) === null || _t === void 0 ? void 0 : _t.icsText);
            return false;
        }
    }
    await icsCreateUpload(uid, currentMail);
    return false;
};
export default calendarSubmit;
